import { render, staticRenderFns } from "./participateinOnePriceActivity.vue?vue&type=template&id=f435d52c&scoped=true"
import script from "./participateinOnePriceActivity.vue?vue&type=script&lang=js"
export * from "./participateinOnePriceActivity.vue?vue&type=script&lang=js"
import style0 from "./participateinOnePriceActivity.vue?vue&type=style&index=0&id=f435d52c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f435d52c",
  null
  
)

export default component.exports